// extracted by mini-css-extract-plugin
module.exports = {"card":"index_card__8qe_3","title":"index_title__LeMBE"};